import {modelbankRequest} from '@/util/request';
import type {
    MaterialSupplier,
    MaterialProperty,
} from '@/types/material-supplier';

export async function getMaterialSuppliers(): Promise<MaterialSupplier[]> {
    const url = '/manage/product_material_suppliers';
    const suppliers = await modelbankRequest<MaterialSupplier[]>(url);

    return suppliers.sort((a, b) => a.name.localeCompare(b.name));
}

export async function getMaterialSupplierProperties(
    supplierId: number
): Promise<MaterialProperty[]> {
    try {
        const url = `/manage/product_material_suppliers/${supplierId}/properties`;

        return await modelbankRequest<MaterialProperty[]>(url);
    } catch {
        return [];
    }
}
